import {
   UPDATE_FILTERS,
   UPDATE_DASHBOARD,
   CREATE_DASHBOARD,
   CURRENT_DATE_RANGE,
   CONTENT_UPDATE,
   SET_INPAGEFILTERS,
   RESET_INPAGEFILTERS,
   RESET_DATERANGES
} from '../constants';
import moment from 'moment';
const INIT_STATE = {
  filters:{dateRanges:[moment().subtract(1,"months").format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")],content:{}},
  inPageFilters:{inPageApis:{},active:{}}

}; 

export default (state = INIT_STATE, action) => {
  var stateRefresh = (action.payload) ? action.payload : action;
  switch (action.type) { 
    case UPDATE_FILTERS:
      return { 
             ...state  
      };
    break;
    case RESET_DATERANGES:
      return {
        ...state,
        inPageFilters:{inPageApis:{},active:{}}
      }
      break;
    case RESET_DATERANGES:
      return {
        ...state,
        filters:{dateRanges:[moment().subtract(1,"months").format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")],content:{}},
        inPageFilters:{inPageApis:{},active:{}}
      }
      break;
      case RESET_INPAGEFILTERS:
        return {
          ...state,
          inPageFilters:{inPageApis:{},active:{}}
        }
        break;
      case SET_INPAGEFILTERS:
      return {
        ...state,
        inPageFilters:{...stateRefresh}
      }
      break;
    case CONTENT_UPDATE:
    return {
      ...state,
      content:{stateRefresh}
    }
    break;
    case UPDATE_DASHBOARD:
      return { 
             ...state
      };
    break;
     case CREATE_DASHBOARD:
      return { 
             ...state,
             newDashboard:{...stateRefresh.data}
      };
    break;
    case CURRENT_DATE_RANGE:
        return {
          ...state,
          filters:{...state.filters,dateRanges:stateRefresh}
        }
        break;
    default:
      return { 
      ...state
};
    break;
  }
};
